// extracted by mini-css-extract-plugin
module.exports = {"label":"Select_label__4loi6","input":"Select_input__QC1he typography-body2","dropdown":"Select_dropdown__srEQV","option":"Select_option__Tul__","error":"Select_error__G1fAs"};